import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Work',
  href: '#work'
}, {
  name: 'About',
  href: '#about'
}, {
  name: 'Writing',
  href: '#writing'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const observerCallback: IntersectionObserverCallback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: '-40% 0px -60% 0px',
      threshold: 0
    });
    navLinks.forEach(({
      href
    }) => {
      const element = document.getElementById(href.substring(1));
      if (element) observer.observe(element);
    });
    const hero = document.getElementById('hero');
    if (hero) observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.getElementById(href.substring(1));
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark/80 backdrop-blur-md border-b border-border' : 'bg-transparent'}`} data-id="element-144">
        <div className="max-w-6xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between" data-id="element-145">
          <a href="#hero" onClick={e => handleNavClick(e, '#hero')} className="text-primary font-semibold text-sm tracking-wide" data-id="element-146">
            Karan Dhir
          </a>

          <nav className="hidden md:flex items-center gap-8" data-id="element-147">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className={`relative text-sm font-medium transition-colors ${activeSection === link.href.substring(1) ? 'text-primary' : 'text-secondary hover:text-primary'}`} data-id="element-148">
                {link.name}
              </a>)}
          </nav>

          <button className="md:hidden text-primary p-2 -mr-2" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-149">
            <Menu className="w-5 h-5" data-id="element-150" />
          </button>
        </div>
      </header>

      <AnimatePresence data-id="element-151">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-dark md:hidden" data-id="element-152">
            <div className="flex flex-col h-full p-6" data-id="element-153">
              <div className="flex justify-end" data-id="element-154">
                <button onClick={() => setIsMobileMenuOpen(false)} className="text-secondary hover:text-primary p-2 -mr-2" aria-label="Close menu" data-id="element-155">
                  <X className="w-5 h-5" data-id="element-156" />
                </button>
              </div>
              <nav className="flex flex-col items-center justify-center flex-1 gap-8" data-id="element-157">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className={`text-2xl font-semibold tracking-tight ${activeSection === link.href.substring(1) ? 'text-primary' : 'text-secondary'}`} data-id="element-158">
                    {link.name}
                  </a>)}
              </nav>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}